import { Component, OnInit, Input, ViewChild, Inject, DOCUMENT } from '@angular/core';
import { DynamicVorlageViewModel } from '../../options/vorlagenVerwaltung/vorlagenVerwaltung-dynamic/dynamic-vorlage.model';
import { AjaxService } from 'AjaxService';
import { DxListComponent } from 'devextreme-angular/ui/list';
import { EntityArt } from '@enums/entityArt.enum';

import { DxValidationGroupComponent } from 'devextreme-angular/ui/validation-group';

@Component({
  selector: 'cz-vorlagen-select',
  templateUrl: 'vorlagen-select.component.html',
  styleUrls: ['./vorlagen-select.component.css'],
  standalone: false,
})
export class VorlagenSelectComponent implements OnInit {
  @ViewChild('vorlagenList', { static: false }) vorlagenList: DxListComponent;
  @ViewChild('platzhalterTargetGroup', { static: false }) platzhalterTargetGroup: DxValidationGroupComponent;

  @Input() entityArt: EntityArt;
  items: DynamicVorlageViewModel[];
  isPopupVisible: boolean;
  isPlatzhalterPopupVisible: boolean;
  isWaitPopupVisible: boolean;
  @Input() entityId: number;

  constructor(
    private _ajaxService: AjaxService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.hidePopup = this.hidePopup.bind(this);
    this.hidePlatzhalterPopup = this.hidePlatzhalterPopup.bind(this);
    this.onPlatzhalterPopupOk = this.onPlatzhalterPopupOk.bind(this);
  }

  ngOnInit() {
    this._ajaxService.post<DynamicVorlageViewModel[]>('api/vorlagenverwaltung/GetDynamicVorlagen', { entityArt: this.entityArt }).subscribe((response) => {
      this.items = response;
    });
  }

  openVorlagenPopup() {
    this.isPopupVisible = true;
  }

  process_createDocument(results: any[]) {
    this.isWaitPopupVisible = true;

    const obj = {
      entityId: this.entityId,
      vorlageId: this.vorlagenList.selectedItems[0].id,
      entityArt: this.entityArt,
      platzhalter: results,
    };

    this._ajaxService.post<any>('api/vorlagenverwaltung/CreateVorlage', obj).subscribe({
      next: (response) => {
        const blob = this.b64toBlob(response.fileContent, response.mimeTyp) || null;
        this.executeDownload(blob, response.fileName);
        this.isWaitPopupVisible = false;
      },
      error: (err) => {
        this.isWaitPopupVisible = false;
        throw err;
      },
    });
  }

  onPlatzhalterPopupOk() {
    const validationFromResult = this.platzhalterTargetGroup.instance.validate();
    if (validationFromResult.isValid) {
      const results: any[] = [];
      (this.vorlagenList.selectedItems[0].platzhalter as any[]).forEach((item) => {
        results.push({
          key: item.key,
          value: item.default,
        });
      });

      this.process_createDocument(results);
    }
  }

  createDocument() {
    if (this.vorlagenList.selectedItems[0]) {
      if (this.vorlagenList.selectedItems[0].platzhalter && this.vorlagenList.selectedItems[0].platzhalter.length > 0) {
        this.isPlatzhalterPopupVisible = true;
      } else {
        this.process_createDocument([]);
      }
    }
  }

  getFileExtension1(filename) {
    return /[.]/.exec(filename) ? '.' + /[^.]+$/.exec(filename)[0] : undefined;
  }

  changeExtension(filename: string, extension: string): string {
    let ext: string = this.getFileExtension1(filename);
    const root: string = filename.substring(0, filename.length - ext.length);

    ext = extension.startsWith('.') ? extension : extension.length > 0 ? `.${extension}` : '';
    return `${root}${ext}`;
  }

  hidePopup() {
    this.isPopupVisible = false;
  }

  hidePlatzhalterPopup() {
    this.isPlatzhalterPopupVisible = false;
  }

  b64toBlob = (content, contentType) => {
    contentType = contentType || '';
    const sliceSize = 512;
    // method which converts base64 to binary
    const byteCharacters = window.atob(content);

    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, {
      type: contentType,
    });
    return blob;
  };

  executeDownload = (blob, fileName) => {
    const url = URL.createObjectURL(blob);
    const link = this.document.createElement('a');
    link.href = url;
    link.download = fileName;
    this.document.body.appendChild(link);
    link.click();

    setTimeout(() => {
      this.document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 1000);
  };
}
